// extracted by mini-css-extract-plugin
export default {"zoomModal":"P0-z","image":"Q0-z","button":"R0-z","isOverlayShown":"S0-z"};